/**
 * Configuration for user identification retry mechanism
 */

/**
 * Maximum number of retry attempts before giving up
 */
export const MAX_RETRY_ATTEMPTS = 3;

/**
 * Progressive backoff intervals for retries (in milliseconds)
 * [30s, 60s, 120s]
 */
export const RETRY_INTERVALS = [
	30000,
	60000,
	120000,
];

/**
 * Period after which retry attempts are reset (24 hours in milliseconds)
 */
export const ATTEMPT_RESET_PERIOD = 86400000;

/**
 * Expiration time for identification cache (5 minutes in milliseconds)
 */
export const EXPIRATION = 300000;
